import numeral from 'numeral';
import currencyList from '@/components/helpers/currency-list';
import { FORMATS } from '@/services/constants/format';
import type { FormatterArgs } from '@/services/types/formatter';
import { compareCellDisplay } from '@/views/formatters/compare_reports';

export default ({ ctx, data, key, decimal = 2 }: FormatterArgs) => {
  const rawValue = data[key] || 0;
  const { currency } = ctx.getReportParams?.() || {};
  const symbol = currencyList[currency as string] || '$ ';

  if (Array.isArray(data[key])) {
    return compareCellDisplay(symbol, [
      numeral(data[key][0] || 0).format(FORMATS[decimal]),
      numeral(data[key][1] || 0).format(FORMATS[decimal]),
      numeral(data[key][2] || 0).format(FORMATS[decimal]),
      numeral(data[key][3] || 0).format(FORMATS[decimal]),
    ]);
  }

  return {
    kind: 'currency',
    amount: numeral(rawValue).format(FORMATS[decimal]),
    symbol,
    columnKey: key,
    numericValue: Number(rawValue),
  };
};
